module.exports = __webpack_public_path__ + "media/images/lb/104-0c632ebf71d2745288c459b68086939b.svg";